export interface ScrenarioNameDetails {
  list: any[];
  name: string;
}

export default function UniqueNameValidator(props: ScrenarioNameDetails) {
  const scenarioNameList = props.list;
  const currentName = props.name;
  return scenarioNameList.length > 0
    ? scenarioNameList.filter(
        (data) =>
          data.name && data.name.toLowerCase() === currentName.toLowerCase()
      )
    : [];
}
